import $ from 'jquery';
import URI from 'urijs';
import fetchUrl from 'utils/fetch';
import { storeSuccess } from './toastr';

export default () => {
  $('.ordering.dropdown').dropdown({
    onChange: onOrderChange,
  });
};

function onOrderChange(value, _, element) {
  const $element = $(element).closest('.ordering');

  const url = $element.attr('data-url');
  if (url && url.length) {
    const orderUrl = URI(url).setSearch({ order: value }).toString();

    // Changing order async then refreshing
    $element.addClass('loading');
    fetchUrl(orderUrl, {
      method: 'POST',
    }).then(_ => {
      storeSuccess('Ordre mis à jour avec succès');
      window.location.reload(true);
    });
  } else {
    console.warn(
      'Trying to reorder an element without required data attribute (url)'
    );
  }
}



// WEBPACK FOOTER //
// ./src/plugins/orderer.js